import { FIELD_LABEL_CLASS } from '@atlas/ui-components'
import { cn, Label } from '@atlas/ui-primitives'
import {
	RULE_SEVERITY_LABEL,
	RULE_SEVERITY_ORDER,
	RULE_TYPE_ORDER,
	type RuleSeverity,
	type RuleType,
	ruleTypeLabel,
} from '@/domain/rules.types'

export interface RuleTypeSeverityValue {
	type: RuleType
	severity: RuleSeverity
}

export interface RuleTypeSeverityFieldsProps extends RuleTypeSeverityValue {
	/** Namespaces the control ids so create and edit can both render on one page. */
	idPrefix: string
	onChange: (next: RuleTypeSeverityValue) => void
}

const fieldLabel = `mb-1.5 block ${FIELD_LABEL_CLASS}`

/** Rule type and severity, shared by the create and edit forms. */
export function RuleTypeSeverityFields({ type, severity, idPrefix, onChange }: RuleTypeSeverityFieldsProps) {
	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
			<div>
				<Label htmlFor={`${idPrefix}-rule-type`} className={fieldLabel}>
					Rule type
				</Label>
				<select
					id={`${idPrefix}-rule-type`}
					value={type}
					onChange={(e) => onChange({ type: e.target.value as RuleType, severity })}
					className="h-9 w-full rounded-ds-md border border-ds-border bg-ds-background px-2 text-sm text-ds-text"
				>
					{RULE_TYPE_ORDER.map((t) => (
						<option key={t} value={t}>
							{ruleTypeLabel(t)}
						</option>
					))}
				</select>
			</div>
			<div>
				<span className={fieldLabel}>Severity</span>
				<div className="flex gap-2">
					{RULE_SEVERITY_ORDER.map((s) => (
						<button
							key={s}
							type="button"
							aria-pressed={severity === s}
							onClick={() => onChange({ type, severity: s })}
							className={cn(
								'rounded-ds-full border px-3 py-1.5 text-xs',
								severity === s ? 'border-ds-text ring-1 ring-ds-text' : 'border-ds-border text-ds-text-muted',
							)}
						>
							{RULE_SEVERITY_LABEL[s]}
						</button>
					))}
				</div>
			</div>
		</div>
	)
}
